exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-49dc3fea] form#KnowledgeCheck fieldset{padding:.5rem;background:-webkit-gradient(linear,left top,right top,from(#fac600),to(#f44));background:linear-gradient(90deg,#fac600,#f44)}@media screen and (max-width:560px){[data-v-49dc3fea] legend.h4.question{line-height:1.2;font-size:5vmin}}", ""]);

// exports
